import { connect, ConnectedProps } from "react-redux";
import { getHotelLoyaltyProgram } from "@capone/common";
import {
  updateUserPassenger,
  fetchCorpUserPassengers,
  fetchUserPassengers,
} from "../../../actions/actions";
import {
  getUserPassengerCallState,
  getUserPassengers,
  getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge,
} from "../../../reducer";
import { IStoreState } from "../../../../../reducers/types";
import { HotelTravelerSelectDropdownForm } from "./component";
import {
  getPremierCollectionShopChosenProductHotelLoyaltyProgramCode,
  getPremierCollectionShopChosenProduct,
} from "../../../../shop/reducer";
import { getFromDate } from "../../../../search/reducer";

const mapStateToProps = (state: IStoreState) => {
  const loyaltyProgramCode =
    getPremierCollectionShopChosenProductHotelLoyaltyProgramCode(state);
  const loyaltyProgram = getHotelLoyaltyProgram(loyaltyProgramCode);

  return {
    travelers: getUserPassengers(state),
    roomsCount: 1,
    chosenProduct: getPremierCollectionShopChosenProduct(state),
    userPassengerCallState: getUserPassengerCallState(state),
    loyaltyProgram,
    minimumCheckInAge:
      getPremierCollectionBookSelectedAvailabilityCheckInMinimumAge(state),
    checkInDate: getFromDate(state),
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
  fetchUserPassengers,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelTravelerSelectDropdownFormConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedHotelTravelerSelectDropdownForm = connector(
  HotelTravelerSelectDropdownForm
);
